import { Node, mergeAttributes } from "@tiptap/core";
import styles from "./Excerpt.module.scss";

const Excerpt = Node.create({
  name: "excerpt",

  content: "text*",

  marks: "",

  group: "block",

  defining: true,

  selectable: false,

  addKeyboardShortcuts() {
    return {
      Enter: () => {
        const selectedNode = this.editor.state.selection.$head.node(
          this.editor.state.selection.$head.depth,
        );

        if (selectedNode.type.name === "excerpt") {
          return true;
        }

        return false;
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "excerpt",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [`p`, mergeAttributes(HTMLAttributes, { class: styles.excerpt }), 0];
  },
});

export default Excerpt;
